<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content="County Health Management System by Nouveta LTD" name="description"/>
      <meta content="Kelvin Njuguna" name="author"/>
      <link href="assets/images/favicon.png" rel="shortcut icon">
      <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css" rel="stylesheet">
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <div id="layout-wrapper">
      <NavigationBar/>

      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">

            <!-- Page Title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">PAID HYGIENE BILLS</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboards</a></li>
                      <li class="breadcrumb-item active">Paid Bills</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- Summary Cards -->
            <div class="row mb-4">
              <div class="col-xl-3 col-md-6">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium">Total Bills</p>
                        <h4 class="mb-0">{{ numberFormat(summary.count) }}</h4>
                      </div>
                      <div class="flex-shrink-0 align-self-center">
                        <div class="mini-stat-icon avatar-sm rounded-circle bg-success">
                          <span class="avatar-title">
                            <i class="bx bx-receipt font-size-24"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-md-6">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium">Total Collected</p>
                        <h4 class="mb-0">KES {{ numberFormat(summary.total) }}</h4>
                      </div>
                      <div class="flex-shrink-0 align-self-center">
                        <div class="mini-stat-icon avatar-sm rounded-circle bg-primary">
                          <span class="avatar-title">
                            <i class="bx bx-money font-size-24"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-md-6">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium">Displayed Records</p>
                        <h4 class="mb-0">{{ billDetails.length }}</h4>
                      </div>
                      <div class="flex-shrink-0 align-self-center">
                        <div class="mini-stat-icon avatar-sm rounded-circle bg-info">
                          <span class="avatar-title">
                            <i class="bx bx-list-ul font-size-24"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-md-6">
                <div class="card mini-stats-wid">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <p class="text-muted fw-medium">Status</p>
                        <h4 class="mb-0 text-success">PAID</h4>
                      </div>
                      <div class="flex-shrink-0 align-self-center">
                        <div class="mini-stat-icon avatar-sm rounded-circle bg-success">
                          <span class="avatar-title">
                            <i class="bx bx-check-circle font-size-24"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <ToolBarHygiene/>

            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                    <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                      <h4 class="card-title text-capitalize mb-0">
                        <i class="bx bx-check-circle me-2"></i>All Paid Bills
                      </h4>
                      <div class="d-flex">
                        <button @click="exportToCSV" class="btn btn-success btn-sm me-3">
                          <i class="bx bx-download me-1"></i> Export CSV
                        </button>
                        <a v-if="getRight('FOOD HYGIENE CREATE BILL')" @click="gotTo('new-bill')"
                           class="btn btn-primary btn-sm" type="button">
                          <i class="mdi mdi-plus-circle-outline font-size-16 me-1"></i>
                          <span>Create A Bill</span>
                        </a>
                      </div>
                    </div>
                  </div>

                  <!-- Filters -->
                  <div class="card-header bg-light pt-3 pb-3">
                    <div class="row g-3">
                      <!-- Search -->
                      <div class="col-md-3">
                        <label class="form-label fw-semibold text-uppercase small">Search</label>
                        <div class="search-box">
                          <div class="position-relative">
                            <input v-model="search" type="text" class="form-control" placeholder="Search bills...">
                            <i class="bx bx-search-alt search-icon"></i>
                          </div>
                        </div>
                      </div>

                      <!-- Date Range -->
                      <div class="col-md-4">
                        <label class="form-label fw-semibold text-uppercase small">Date Range</label>
                        <div class="d-flex align-items-center gap-2">
                          <input class="form-control" type="date" v-model="dateFrom" placeholder="From">
                          <span class="text-muted">to</span>
                          <input class="form-control" type="date" v-model="dateTo" placeholder="To">
                        </div>
                      </div>

                      <!-- Filter Type -->
                      <div class="col-md-2">
                        <label class="form-label fw-semibold text-uppercase small">Filter By</label>
                        <select class="form-select" v-model="filter">
                          <option value="filter-all">All Transactions</option>
                          <option value="filter-sub-county">Sub County</option>
                          <option value="filter-wards">Ward</option>
                          <option value="filer-zone">Zone</option>
                          <option value="filter-officer">Officer</option>
                        </select>
                      </div>

                      <!-- Filter Value -->
                      <div class="col-md-3">
                        <label class="form-label fw-semibold text-uppercase small">Select Option</label>
                        <select class="form-select" v-model="selectedItem">
                          <option :key="index" :value="item.value" v-for="(item, index) in itemList">
                            {{ item.value }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="card-body">
                    <!-- Loading State -->
                    <div v-if="loading" class="text-center py-5">
                      <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <p class="mt-2">Loading paid bills...</p>
                    </div>

                    <!-- Empty State -->
                    <div v-else-if="billDetails.length < 1" class="text-center py-5">
                      <div class="mb-4">
                        <i class="bx bx-search-alt font-size-64 text-muted"></i>
                      </div>
                      <h5 class="text-muted">No Paid Bills Found</h5>
                      <p class="text-muted">Try adjusting your search or filter criteria</p>
                    </div>

                    <!-- Table -->
                    <div v-else class="table-responsive">
                      <table class="table align-middle table-hover table-nowrap mb-0">
                        <thead class="table-light">
                        <tr>
                          <th class="text-nowrap">NO.</th>
                          <th class="text-nowrap">Bill No</th>
                          <th class="text-nowrap">Description</th>
                          <th class="text-nowrap">Sub County</th>
                          <th class="text-nowrap">Ward</th>
                          <th class="text-nowrap">Zone</th>
                          <th class="text-nowrap">Attendant</th>
                          <th class="text-nowrap text-end">Billed Amount</th>
                          <th class="text-nowrap text-end">Amount Paid</th>
                          <th class="text-nowrap text-end">Balance</th>
                          <th class="text-nowrap">Status</th>
                          <th class="text-nowrap">Date</th>
                          <th class="text-nowrap text-end">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr :key="index" v-for="(item, index) in billDetails" class="hover-row">
                          <td class="text-nowrap">{{ index + 1 }}</td>
                          <td class="text-nowrap">
                            <span class="badge bg-success-subtle text-success">{{ item.billNo }}</span>
                          </td>
                          <td class="text-capitalize">{{ item.feeDescription }}</td>
                          <td class="text-capitalize">{{ item.subCountyName }}</td>
                          <td class="text-capitalize">{{ item.wardName }}</td>
                          <td class="text-capitalize">{{ item.zone }}</td>
                          <td class="text-capitalize">{{ item.names }}</td>
                          <td class="text-end fw-semibold">{{ formatPrice(item.detailAmount) }}</td>
                          <td class="text-end fw-semibold text-success">{{ formatPrice(item.receiptAmount) }}</td>
                          <td class="text-end fw-semibold">{{ formatPrice(item.billBalance) }}</td>
                          <td>
                            <span class="badge bg-success">{{ item.status }}</span>
                          </td>
                          <td class="text-nowrap">{{ formatDateTime(item.dateCreated) }}</td>
                          <td class="text-end">
                            <div class="d-flex justify-content-end gap-1">
                              <button @click="getBill(item.billNo)" class="btn btn-soft-primary btn-sm"
                                      data-bs-toggle="modal" data-bs-target="#billDetail" title="View Details">
                                <i class="bx bx-show"></i>
                              </button>
                              <button @click="printBill(item.billNo)" class="btn btn-soft-success btn-sm" title="Print">
                                <i class="bx bx-printer"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                        <tfoot class="table-dark">
                        <tr>
                          <th colspan="7" class="text-nowrap">{{ billDetails.length }} Bills</th>
                          <td class="text-end fw-semibold">{{ totalDetailAmount }}</td>
                          <td class="text-end fw-semibold">{{ totalReceiptAmount }}</td>
                          <td class="text-end fw-semibold">{{ totalBillBalance }}</td>
                          <th colspan="3"></th>
                        </tr>
                        </tfoot>
                      </table>
                    </div>

                    <!-- Pagination -->
                    <div v-if="billDetails.length > 0" class="row mt-4">
                      <div class="col-sm-12 col-md-5">
                        <div class="dataTables_info">
                          Showing {{ startIndex + 1 }} to {{ Math.min(endIndex, summary.count) }} of {{ summary.count }} entries
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-7">
                        <div class="d-flex justify-content-end align-items-center gap-3">
                          <div class="d-flex align-items-center gap-2">
                            <span class="text-muted small">Rows per page:</span>
                            <select class="form-select form-select-sm" v-model="pageSize" style="width: auto;">
                              <option value="10">10</option>
                              <option value="25">25</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                            </select>
                          </div>
                          <ul class="pagination pagination-rounded mb-0">
                            <li class="page-item" :class="{ disabled: currentPage === 1 }">
                              <a class="page-link" @click="prevPage">
                                <i class="mdi mdi-chevron-left"></i>
                              </a>
                            </li>
                            <li v-for="page in pagination(currentPage, totalPages, 3)" :key="page"
                                class="page-item" :class="{ active: currentPage === page }">
                              <span v-if="page === '...'" class="page-link">{{ page }}</span>
                              <a v-else class="page-link" @click="goToPage(page)">{{ page }}</a>
                            </li>
                            <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                              <a class="page-link" @click="nextPage">
                                <i class="mdi mdi-chevron-right"></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Bill Detail Modal -->
        <div class="modal fade" id="billDetail" tabindex="-1" aria-labelledby="billDetailLabel" aria-hidden="true">
          <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
              <div class="modal-header bg-primary text-white">
                <h5 class="modal-title" id="billDetailLabel">
                  <i class="bx bx-receipt me-2"></i>Bill Details - {{ billNo }}
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <!-- Loading State -->
                <div v-if="billLoading" class="text-center py-5">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <p class="mt-2">Loading bill details...</p>
                </div>

                <div v-else>
                  <!-- Bill Summary Card -->
                  <div class="card bg-light mb-4">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-6">
                          <h6 class="text-muted mb-3">BILL INFORMATION</h6>
                          <table class="table table-sm table-borderless mb-0">
                            <tr>
                              <td class="text-muted" style="width: 150px;">Bill No:</td>
                              <td class="fw-semibold">{{ billDetailData.billNo }}</td>
                            </tr>
                            <tr>
                              <td class="text-muted">Description:</td>
                              <td>{{ billDetailData.feeDescription }}</td>
                            </tr>
                            <tr>
                              <td class="text-muted">Income Type:</td>
                              <td>{{ billDetailData.incomeTypeDescription }}</td>
                            </tr>
                            <tr>
                              <td class="text-muted">Department:</td>
                              <td>{{ billDetailData.department }}</td>
                            </tr>
                            <tr>
                              <td class="text-muted">Date Created:</td>
                              <td>{{ formatDateTime(billDetailData.dateCreated) }}</td>
                            </tr>
                          </table>
                        </div>
                        <div class="col-md-6">
                          <h6 class="text-muted mb-3">PAYMENT DETAILS</h6>
                          <table class="table table-sm table-borderless mb-0">
                            <tr>
                              <td class="text-muted" style="width: 150px;">Bill Amount:</td>
                              <td class="fw-semibold text-primary">{{ formatPrice(billDetailData.detailAmount) }}</td>
                            </tr>
                            <tr>
                              <td class="text-muted">Amount Paid:</td>
                              <td class="fw-semibold text-success">{{ formatPrice(billDetailData.receiptAmount) }}</td>
                            </tr>
                            <tr>
                              <td class="text-muted">Balance:</td>
                              <td class="fw-semibold text-danger">{{ formatPrice(billDetailData.billBalance) }}</td>
                            </tr>
                            <tr>
                              <td class="text-muted">Status:</td>
                              <td><span class="badge" :class="billDetailData.status === 'PAID' ? 'bg-success' : 'bg-warning'">{{ billDetailData.status }}</span></td>
                            </tr>
                            <tr>
                              <td class="text-muted">Created By:</td>
                              <td>{{ billDetailData.names }}</td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Step 1: Bill Info Items -->
                  <div class="card mb-4">
                    <div class="card-header bg-white d-flex justify-content-between align-items-center">
                      <h6 class="mb-0">
                        <span class="badge bg-primary rounded-circle me-2">1</span>
                        Select a Fee Item to Map
                      </h6>
                      <span class="badge bg-info">{{ billInfo.length }} Items</span>
                    </div>
                    <div class="card-body p-0">
                      <div class="table-responsive">
                        <table class="table table-hover mb-0">
                          <thead class="table-light">
                          <tr>
                            <th style="width: 50px;"></th>
                            <th>Fee Description</th>
                            <th>Amount</th>
                            <th>Receipt Amount</th>
                            <th>Balance</th>
                            <th>Current Mapping</th>
                            <th>Status</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(item, index) in billInfo" :key="index"
                              :class="{ 'table-primary': selectedBillInfoId === item.id }"
                              @click="selectBillInfo(item)" style="cursor: pointer;">
                            <td>
                              <input type="radio" class="form-check-input"
                                     :checked="selectedBillInfoId === item.id"
                                     @change="selectBillInfo(item)">
                            </td>
                            <td class="fw-semibold">{{ item.feeDescription }}</td>
                            <td>{{ formatPrice(item.billTotal) }}</td>
                            <td class="text-success">{{ formatPrice(item.receiptAmount) }}</td>
                            <td class="text-danger">{{ formatPrice(item.billBalance) }}</td>
                            <td>
                              <span v-if="item.customer" class="badge bg-success-subtle text-success">
                                {{ item.customer }}
                              </span>
                              <span v-else class="badge bg-warning-subtle text-warning">
                                Not Mapped
                              </span>
                            </td>
                            <td>
                              <span v-if="item.customer" class="text-success">
                                <i class="bx bx-check-circle"></i> Mapped
                              </span>
                              <span v-else class="text-warning">
                                <i class="bx bx-error-circle"></i> Pending
                              </span>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <!-- Step 2: Search or Register Business (Only visible when billInfo is selected) -->
                  <div v-if="selectedBillInfoId" class="card mb-4">
                    <div class="card-header bg-white d-flex justify-content-between align-items-center">
                      <h6 class="mb-0">
                        <span class="badge bg-primary rounded-circle me-2">2</span>
                        Search or Register a Business
                      </h6>
                      <div class="btn-group btn-group-sm">
                        <button type="button" class="btn"
                                :class="businessMode === 'search' ? 'btn-primary' : 'btn-outline-primary'"
                                @click="businessMode = 'search'">
                          <i class="bx bx-search me-1"></i> Search Existing
                        </button>
                        <button type="button" class="btn"
                                :class="businessMode === 'register' ? 'btn-primary' : 'btn-outline-primary'"
                                @click="businessMode = 'register'">
                          <i class="bx bx-plus me-1"></i> Register New
                        </button>
                      </div>
                    </div>
                    <div class="card-body">
                      <div class="alert alert-info d-flex align-items-center mb-3">
                        <i class="bx bx-info-circle me-2 font-size-20"></i>
                        <div>
                          Mapping: <strong>{{ selectedBillInfoItem?.feeDescription }}</strong>
                          ({{ formatPrice(selectedBillInfoItem?.billTotal) }})
                        </div>
                      </div>

                      <!-- Search Mode -->
                      <div v-if="businessMode === 'search'">
                        <div class="search-box mb-3">
                          <div class="position-relative">
                            <input v-model="keyword" type="text" class="form-control form-control-lg"
                                   placeholder="Search businesses by name, ID, or phone...">
                            <i class="bx bx-search-alt search-icon"></i>
                          </div>
                        </div>

                        <!-- Businesses Table -->
                        <div v-if="businesses.length > 0" class="table-responsive" style="max-height: 300px; overflow-y: auto;">
                          <table class="table table-hover table-sm mb-0">
                            <thead class="table-light sticky-top">
                            <tr>
                              <th style="width: 50px;"></th>
                              <th>Business ID</th>
                              <th>Business Name</th>
                              <th>Owner</th>
                              <th>Phone</th>
                              <th>Sub County</th>
                              <th>Ward</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, index) in businesses" :key="index"
                                :class="{ 'table-success': selectedBusinessID === item.businessID }"
                                @click="selectBusiness(item.businessID)" style="cursor: pointer;">
                              <td>
                                <input type="radio" class="form-check-input"
                                       :checked="selectedBusinessID === item.businessID"
                                       @change="selectBusiness(item.businessID)">
                              </td>
                              <td><span class="badge bg-primary">{{ item.businessID }}</span></td>
                              <td class="fw-semibold">{{ item.businessName }}</td>
                              <td>{{ item.fullNames }}</td>
                              <td><a :href="'tel:' + item.ownerPhone">{{ item.ownerPhone }}</a></td>
                              <td>{{ item.subCountyName }}</td>
                              <td>{{ item.wardName }}</td>
                            </tr>
                            </tbody>
                          </table>
                        </div>

                        <!-- No results found -->
                        <div v-else-if="keyword && keyword.length >= 2 && !searchingBusiness" class="text-center py-4">
                          <div class="mb-3">
                            <i class="bx bx-search font-size-48 text-muted"></i>
                          </div>
                          <h6 class="text-muted">No businesses found for "{{ keyword }}"</h6>
                          <p class="text-muted mb-3">Would you like to register a new business?</p>
                          <button type="button" class="btn btn-primary" @click="businessMode = 'register'">
                            <i class="bx bx-plus me-1"></i> Register New Business
                          </button>
                        </div>

                        <!-- Initial state -->
                        <div v-else-if="!keyword || keyword.length < 2" class="text-center py-4 text-muted">
                          <i class="bx bx-search font-size-48"></i>
                          <p class="mt-2">Enter at least 2 characters to search for businesses</p>
                        </div>

                        <!-- Searching -->
                        <div v-else-if="searchingBusiness" class="text-center py-4">
                          <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Searching...</span>
                          </div>
                          <p class="mt-2">Searching businesses...</p>
                        </div>
                      </div>

                      <!-- Register Mode -->
                      <div v-if="businessMode === 'register'">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="mb-3">
                              <label class="form-label">Name of Establishment <span class="text-danger">*</span></label>
                              <input v-model="newBusiness.businessName" type="text" class="form-control" placeholder="Enter Business Name">
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="mb-3">
                              <label class="form-label">Building/Premises Name</label>
                              <input v-model="newBusiness.buildingName" type="text" class="form-control" placeholder="Building Name">
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="mb-3">
                              <label class="form-label">Sub County <span class="text-danger">*</span></label>
                              <select v-model="selectedSubCounty" class="form-select">
                                <option :value="null">Select Sub County</option>
                                <option v-for="(item, index) in subCounties" :value="item" :key="index">
                                  {{ item.subCountyName }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="mb-3">
                              <label class="form-label">Ward <span class="text-danger">*</span></label>
                              <select v-model="selectedWard" class="form-select">
                                <option :value="null">Select Ward</option>
                                <option v-for="(item, index) in wards" :value="item" :key="index">
                                  {{ item.wardName }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="mb-3">
                              <label class="form-label">Applicant's Name <span class="text-danger">*</span></label>
                              <input v-model="newBusiness.fullNames" type="text" class="form-control" placeholder="e.g. John Doe">
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="mb-3">
                              <label class="form-label">Applicant's Phone <span class="text-danger">*</span></label>
                              <input v-model="newBusiness.ownerPhone" type="text" class="form-control" placeholder="e.g. 0712345678">
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="mb-3">
                              <label class="form-label">Applicant's Email</label>
                              <input v-model="newBusiness.ownerEmail" type="email" class="form-control" placeholder="email@example.com">
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="mb-3">
                              <label class="form-label">Postal Address</label>
                              <input v-model="newBusiness.postalAddress" type="text" class="form-control" placeholder="e.g. 123-00100 Nairobi">
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="mb-3">
                              <label class="form-label">Plot Number</label>
                              <input v-model="newBusiness.plotNumber" type="text" class="form-control" placeholder="Plot Number">
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="mb-3">
                              <label class="form-label">Nature of Business</label>
                              <input v-model="newBusiness.businessDes" type="text" class="form-control" placeholder="e.g. Restaurant, Supermarket">
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="mb-3">
                              <label class="form-label">Physical Address</label>
                              <textarea v-model="newBusiness.physicalAddress" class="form-control" rows="2" placeholder="Enter Physical Address"></textarea>
                            </div>
                          </div>
                        </div>

                        <!-- Validation message -->
                        <div v-if="registrationError" class="alert alert-danger">
                          <i class="bx bx-error-circle me-2"></i> {{ registrationError }}
                        </div>

                        <!-- Register button -->
                        <div class="d-flex justify-content-end">
                          <button type="button" class="btn btn-outline-secondary me-2" @click="businessMode = 'search'">
                            <i class="bx bx-arrow-back me-1"></i> Back to Search
                          </button>
                          <button type="button" class="btn btn-success" @click="registerNewBusiness" :disabled="registering">
                            <span v-if="registering">
                              <span class="spinner-border spinner-border-sm me-1"></span> Registering...
                            </span>
                            <span v-else>
                              <i class="bx bx-check me-1"></i> Register & Select
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Step 3: Confirm Mapping (Only visible when both are selected) -->
                  <div v-if="selectedBillInfoId && selectedBusinessID" class="card border-success">
                    <div class="card-header bg-success text-white">
                      <h6 class="mb-0">
                        <span class="badge bg-white text-success rounded-circle me-2">3</span>
                        Confirm Mapping
                      </h6>
                    </div>
                    <div class="card-body">
                      <div class="row align-items-center">
                        <div class="col-md-5">
                          <div class="p-3 bg-light rounded">
                            <h6 class="text-muted mb-2">Fee Item</h6>
                            <p class="fw-semibold mb-1">{{ selectedBillInfoItem?.feeDescription }}</p>
                            <p class="text-primary mb-0">{{ formatPrice(selectedBillInfoItem?.billTotal) }}</p>
                          </div>
                        </div>
                        <div class="col-md-2 text-center">
                          <i class="bx bx-right-arrow-alt font-size-32 text-success"></i>
                        </div>
                        <div class="col-md-5">
                          <div class="p-3 bg-light rounded">
                            <h6 class="text-muted mb-2">Business</h6>
                            <p class="fw-semibold mb-1">{{ selectedBusinessData?.businessName }}</p>
                            <p class="text-primary mb-0">ID: {{ selectedBusinessID }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="alert alert-warning mt-3 mb-0">
                        <i class="bx bx-info-circle me-2"></i>
                        <strong>Note:</strong> The business will be registered in the health system first, then mapped to this fee item.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-light" data-bs-dismiss="modal">
                  <i class="bx bx-x me-1"></i> Close
                </button>
                <button @click="printBillModal()" class="btn btn-outline-primary">
                  <i class="bx bx-printer me-1"></i> Print Bill
                </button>
                <button v-if="selectedBillInfoId && selectedBusinessID"
                        @click="mapBusiness()"
                        class="btn btn-success"
                        :disabled="mapping">
                  <span v-if="mapping">
                    <span class="spinner-border spinner-border-sm me-1"></span> {{ mappingStatus }}
                  </span>
                  <span v-else>
                    <i class="bx bx-link me-1"></i> Register & Map Business
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6"></div>
              <div class="col-sm-6">
                <div class="text-sm-end d-sm-block">Developed by County</div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import {authUrl, biller, execute, health, getRight} from "@/api";
import NavigationBar from "@/components/Navigation";
import router from "@/router";
import ToolBarHygiene from "@/components/hygiene/ToolBarHygiene.vue";

export default {
  name: "HygienePaidBills",
  components: {ToolBarHygiene, NavigationBar},
  data() {
    return {
      keyword: '',
      selectedFeeID: null,
      selectedBusinessID: null,
      selectedBusinessData: null,
      selectedBillInfoId: null,
      selectedBillInfoItem: null,
      search: '',
      loading: false,
      billLoading: false,
      mapping: false,
      mappingStatus: 'Processing...',
      searchingBusiness: false,
      registering: false,
      registrationError: '',
      businessMode: 'search', // 'search' or 'register'
      currentPage: 1,
      totalPages: 0,
      pageSize: 25,
      summary: {
        count: 0,
        total: 0
      },
      totalAmount: null,
      selectedItem: null,
      itemList: [{id: null, value: null}],
      filter: 'filter-all',
      dateFrom: '',
      dateTo: '',
      message: '',
      billDetails: [],
      billDetailData: {},
      billInfo: [],
      billNo: '',
      businesses: [],

      // Sub counties and wards for registration
      subCounties: [],
      wards: [],
      selectedSubCounty: null,
      selectedWard: null,

      // New business registration form
      newBusiness: {
        businessID: null,
        businessName: '',
        subCountyID: null,
        subCountyName: '',
        wardID: null,
        wardName: '',
        plotNumber: '',
        physicalAddress: '',
        buildingName: '',
        buildingOccupancy: '',
        floorNo: '',
        roomNo: '',
        premiseSize: '',
        numberOfEmployees: '',
        tonnage: '',
        businessDes: '',
        businessCategory: '',
        businessSubCategory: '',
        incomeTypeID: '',
        feeID: '',
        businessEmail: '',
        postalAddress: '',
        postalCode: '',
        businessPhone: '',
        contactPersonNames: '',
        contactPersonIDNo: '',
        businessRole: '',
        contactPersonPhone: '',
        contactPersonEmail: '',
        fullNames: '',
        ownerID: '',
        ownerPhone: '',
        ownerEmail: '',
        kraPin: '',
        createdBy: '',
        createdByIDNo: '',
        dateCreated: '',
        lat: 0,
        lng: 0
      }
    }
  },
  watch: {
    pageSize(newPageSize) {
      this.currentPage = 1;
      this.getBills();
    },
    search() {
      this.currentPage = 1;
      this.getBills();
    },
    keyword(newValue) {
      if (newValue && newValue.length >= 2) {
        this.getBusinesses(newValue);
      } else {
        this.businesses = [];
      }
    },
    selectedItem(newValue) {
      this.currentPage = 1;
      this.getBills();
    },
    dateFrom(newValue) {
      if (this.dateFrom !== '' && this.dateTo !== '') {
        this.currentPage = 1;
        this.getBills();
      }
    },
    dateTo(newValue) {
      if (this.dateFrom !== '' && this.dateTo !== '') {
        this.currentPage = 1;
        this.getBills();
      }
    },
    filter(newValue) {
      if (newValue === 'filter-all') {
        this.currentPage = 1;
        this.getBills();
      } else if (newValue === 'filter-sub-county') {
        this.getSubCountiesFilter();
      } else if (newValue === 'filter-wards') {
        this.getWardsFilter();
      } else if (newValue === 'filer-zone') {
        this.getZones();
      } else if (newValue === 'filter-officer') {
        this.getUsers();
      }
    },
    selectedSubCounty(newValue) {
      if (newValue) {
        this.newBusiness.subCountyID = newValue.subCountyID;
        this.newBusiness.subCountyName = newValue.subCountyName;
        this.getWards(newValue.subCountyID);
      } else {
        this.wards = [];
        this.selectedWard = null;
      }
    },
    selectedWard(newValue) {
      if (newValue) {
        this.newBusiness.wardID = newValue.wardID;
        this.newBusiness.wardName = newValue.wardName;
      }
    }
  },
  computed: {
    startIndex() {
      return (this.currentPage - 1) * this.pageSize;
    },
    endIndex() {
      return this.currentPage * this.pageSize;
    },
    totalReceiptAmount() {
      return this.formatPrice(this.billDetails.reduce((sum, billDetail) => sum + parseInt(billDetail.receiptAmount), 0));
    },
    totalBillBalance() {
      return this.formatPrice(this.billDetails.reduce((sum, billDetail) => sum + parseInt(billDetail.billBalance), 0));
    },
    totalDetailAmount() {
      return this.formatPrice(this.billDetails.reduce((sum, billDetail) => sum + parseInt(billDetail.detailAmount), 0));
    }
  },
  mounted() {
    this.menuAccess();
    this.getBills();
    this.getSubCounties();
  },
  methods: {
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Hygiene Paid Bill");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller).catch((e) => console.error('Menu access error:', e.message));
    },
    selectBillInfo(item) {
      this.selectedBillInfoId = item.id;
      this.selectedBillInfoItem = item;
      // Reset business selection when changing bill info item
      this.selectedBusinessID = null;
      this.selectedBusinessData = null;
      this.keyword = '';
      this.businesses = [];
      this.businessMode = 'search';
      this.resetNewBusinessForm();
    },
    selectBusiness(businessID) {
      this.selectedBusinessID = businessID;
      this.selectedBusinessData = this.businesses.find(b => b.businessID === businessID);
    },
    resetNewBusinessForm() {
      this.newBusiness = {
        businessID: null,
        businessName: '',
        subCountyID: null,
        subCountyName: '',
        wardID: null,
        wardName: '',
        plotNumber: '',
        physicalAddress: '',
        buildingName: '',
        buildingOccupancy: '',
        floorNo: '',
        roomNo: '',
        premiseSize: '',
        numberOfEmployees: '',
        tonnage: '',
        businessDes: '',
        businessCategory: '',
        businessSubCategory: '',
        incomeTypeID: '',
        feeID: '',
        businessEmail: '',
        postalAddress: '',
        postalCode: '',
        businessPhone: '',
        contactPersonNames: '',
        contactPersonIDNo: '',
        businessRole: '',
        contactPersonPhone: '',
        contactPersonEmail: '',
        fullNames: '',
        ownerID: '',
        ownerPhone: '',
        ownerEmail: '',
        kraPin: '',
        createdBy: '',
        createdByIDNo: '',
        dateCreated: '',
        lat: 0,
        lng: 0
      };
      this.selectedSubCounty = null;
      this.selectedWard = null;
      this.registrationError = '';
    },
    getRight(type) {
      return getRight(type);
    },
    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);
      if (start < 1) {
        start = 1;
        end = start + maxVisibleButtons - 1;
        if (end > totalPages) end = totalPages;
      }
      if (end > totalPages) {
        end = totalPages;
        start = end - maxVisibleButtons + 1;
        if (start < 1) start = 1;
      }
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      if (start > 1) pages.unshift("...");
      if (end < totalPages) pages.push("...");
      return pages;
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getBills();
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getBills();
      }
    },
    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getBills();
      }
    },
    numberFormat(num) {
      if (!num) return '0';
      return new Intl.NumberFormat("en-GB").format(num);
    },
    formatPrice(value) {
      if (!value) return 'KES 0.00';
      return new Intl.NumberFormat('en-KE', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      }).format(value);
    },
    formatDateTime(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleString('en-KE', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    gotTo(route) {
      router.push(route);
    },
    getBills() {
      this.billDetails = [];
      this.loading = true;
      const data = new FormData();
      data.append("function", "getBillsPaginate");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("status", "PAID");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);

      if (this.search && this.search.trim() !== '') {
        data.append("keyword", this.search.trim());
      } else {
        data.append("incomeTypePrefix", "PUBLIC-HEALTH");
      }

      execute(data, biller)
          .then((res) => {
            this.loading = false;
            this.summary.count = 0;
            this.summary.total = 0;
            if (res.data.success) {
              this.billDetails = res.data.data.billDetails;
              this.summary = res.data.data.summary;
              this.totalPages = Math.ceil(this.summary.count / this.pageSize);
              this.totalAmount = this.billDetails.reduce((acc, cur) => {
                let receiptAmount = Number(cur.receiptAmount);
                return acc + receiptAmount;
              }, 0);
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.loading = false;
            this.message = e.message;
          });
    },
    getBusinesses(keyword) {
      this.searchingBusiness = true;
      const data = new FormData();
      data.append("function", "getBusinesses");
      data.append("keyword", keyword);
      execute(data, health)
          .then((res) => {
            this.searchingBusiness = false;
            if (res.data.success) {
              this.businesses = res.data.data.businesses;
            } else {
              this.businesses = [];
            }
          })
          .catch((e) => {
            this.searchingBusiness = false;
            this.businesses = [];
            console.error('Error:', e.message);
          });
    },
    getBill(billNo) {
      this.billNo = billNo;
      this.billLoading = true;
      this.billDetailData = {};
      this.billInfo = [];
      // Reset selections
      this.selectedBillInfoId = null;
      this.selectedBillInfoItem = null;
      this.selectedBusinessID = null;
      this.selectedBusinessData = null;
      this.keyword = '';
      this.businesses = [];
      this.businessMode = 'search';
      this.resetNewBusinessForm();

      const data = new FormData();
      data.append("function", "getBill");
      data.append("billNo", billNo);
      execute(data, biller)
          .then((res) => {
            this.billLoading = false;
            if (res.data.success) {
              this.billDetailData = res.data.data.billDetails || {};
              this.billInfo = res.data.data.billInfo || [];
            }
          })
          .catch((e) => {
            this.billLoading = false;
            console.error('Error:', e.message);
          });
    },

    // Get sub counties for registration form
    getSubCounties() {
      const data = new FormData();
      data.append("function", "getSubCounty");
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.subCounties = res.data.data.subCounties || res.data.data;
            }
          })
          .catch((e) => console.error('Error:', e.message));
    },

    // Get wards based on selected sub county
    getWards(subCountyID) {
      this.wards = [];
      this.selectedWard = null;
      const data = new FormData();
      data.append("function", "getWards");
      data.append("subCountyID", subCountyID);
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.wards = res.data.data.wards || res.data.data;
            }
          })
          .catch((e) => console.error('Error:', e.message));
    },

    // Register new business
    registerNewBusiness() {
      // Validate required fields
      this.registrationError = '';

      if (!this.newBusiness.businessName) {
        this.registrationError = 'Business name is required';
        return;
      }
      if (!this.newBusiness.subCountyID) {
        this.registrationError = 'Sub County is required';
        return;
      }
      if (!this.newBusiness.wardID) {
        this.registrationError = 'Ward is required';
        return;
      }
      if (!this.newBusiness.fullNames) {
        this.registrationError = "Applicant's name is required";
        return;
      }
      if (!this.newBusiness.ownerPhone) {
        this.registrationError = "Applicant's phone is required";
        return;
      }

      this.registering = true;
      const data = new FormData();
      data.append("function", "registerBusiness");
      data.append("business", JSON.stringify(this.newBusiness));

      execute(data, health)
          .then((res) => {
            this.registering = false;
            if (res.data.success) {
              // Get the registered business and select it
              const registeredBusiness = res.data.data.business;
              this.selectedBusinessID = registeredBusiness.businessID;
              this.selectedBusinessData = registeredBusiness;

              // Switch back to search mode and show success
              this.businessMode = 'search';
              alert('Business registered successfully! You can now map it.');
            } else {
              this.registrationError = res.data.message || 'Failed to register business';
            }
          })
          .catch((e) => {
            this.registering = false;
            this.registrationError = e.message || 'Failed to register business';
          });
    },

    // Step 1: Main map business function
    mapBusiness() {
      if (!this.selectedBillInfoId || !this.selectedBusinessID) {
        alert('Please select both a fee item and a business');
        return;
      }

      this.mapping = true;
      this.mappingStatus = 'Registering business...';

      // First register the business to get a new businessID
      this.registerBusinessForMapping();
    },

    // Step 2: Register business in health system
    registerBusinessForMapping() {
      const data = new FormData();
      data.append("function", "registerBusiness");
      data.append("business", JSON.stringify(this.selectedBusinessData));

      execute(data, health)
          .then((res) => {
            if (res.data.success) {
              // Get the new businessID from the response
              const newBusinessID = res.data.data.business.businessID;
              this.mappingStatus = 'Mapping to bill...';

              // Now map using the new businessID
              this.mapBillInfoToBusiness(newBusinessID);
            } else {
              this.mapping = false;
              this.mappingStatus = 'Processing...';
              alert('Error registering business: ' + res.data.message);
            }
          })
          .catch((e) => {
            this.mapping = false;
            this.mappingStatus = 'Processing...';
            alert('Error registering business: ' + e.message);
          });
    },

    // Step 3: Map the billInfo to the new business
    mapBillInfoToBusiness(businessID) {
      const data = new FormData();
      data.append("function", "mapBillInfoToBusiness");
      data.append("billInfoId", this.selectedBillInfoId);
      data.append("businessID", businessID);

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.mappingStatus = 'Updating records...';
              // Call updateServiceRecordsForBill
              this.updateServiceRecordsForBill(this.billNo);
            } else {
              this.mapping = false;
              this.mappingStatus = 'Processing...';
              alert('Error mapping business: ' + res.data.message);
            }
          })
          .catch((e) => {
            this.mapping = false;
            this.mappingStatus = 'Processing...';
            alert('Error mapping business: ' + e.message);
          });
    },

    // Step 4: Update service records
    updateServiceRecordsForBill(billNo) {
      const data = new FormData();
      data.append("function", "updateServiceRecordsForBill");
      data.append("billNo", billNo);

      execute(data, biller)
          .then((res) => {
            this.mapping = false;
            this.mappingStatus = 'Processing...';
            if (res.data.success) {
              alert('Business registered, mapped and service records updated successfully!');
              // Refresh the bill data
              this.getBill(this.billNo);
            } else {
              alert('Business mapped but service records update failed: ' + res.data.message);
              // Still refresh to show the mapping
              this.getBill(this.billNo);
            }
          })
          .catch((e) => {
            this.mapping = false;
            this.mappingStatus = 'Processing...';
            alert('Business mapped but service records update failed: ' + e.message);
            // Still refresh to show the mapping
            this.getBill(this.billNo);
          });
    },

    generateEntryCert(billNo) {
      const data = new FormData();
      data.append("function", "generateFireEntryCert");
      data.append("billNo", billNo);
      data.append("businessID", this.selectedBusinessID);
      execute(data, biller)
          .then((res) => alert(res.data.message))
          .catch((e) => alert('Error: ' + e.message));
    },
    printBill(billNo) {
      localStorage['params'] = JSON.stringify({billNo: billNo});
      const routeData = this.$router.resolve({name: 'bill'});
      window.open(routeData.href, '_blank');
    },
    printBillModal() {
      this.printBill(this.billNo);
    },
    exportToCSV() {
      try {
        const headers = ['No', 'Bill No', 'Description', 'Sub County', 'Ward', 'Zone', 'Attendant', 'Billed Amount', 'Amount Paid', 'Balance', 'Status', 'Date'];
        const rows = this.billDetails.map((item, index) => [
          index + 1,
          item.billNo || '',
          item.feeDescription || '',
          item.subCountyName || '',
          item.wardName || '',
          item.zone || '',
          item.names || '',
          item.detailAmount || 0,
          item.receiptAmount || 0,
          item.billBalance || 0,
          item.status || '',
          item.dateCreated || ''
        ]);
        let csvContent = headers.join(',') + '\n';
        rows.forEach(row => {
          const escapedRow = row.map(field => {
            const stringField = String(field);
            if (stringField.includes(',') || stringField.includes('"') || stringField.includes('\n')) {
              return `"${stringField.replace(/"/g, '""')}"`;
            }
            return stringField;
          });
          csvContent += escapedRow.join(',') + '\n';
        });
        csvContent += '\n';
        csvContent += `Total Records,${this.billDetails.length}\n`;
        csvContent += `Total Amount,KES ${this.numberFormat(this.summary.total)}\n`;
        const blob = new Blob([csvContent], {type: 'text/csv;charset=utf-8;'});
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `paid-hygiene-bills-${new Date().toISOString().split('T')[0]}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        alert(`Successfully exported ${this.billDetails.length} records to CSV`);
      } catch (error) {
        console.error('Export error:', error);
        alert('Error exporting data to CSV. Please try again.');
      }
    },
    getSubCountiesFilter() {
      this.itemList = [];
      const data = new FormData();
      data.append("function", "getSubCounty");
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              const subCounties = res.data.data.subCounties || res.data.data;
              for (let i = 0; i < subCounties.length; i++) {
                let subCounty = subCounties[i];
                this.itemList.push({id: subCounty.subCountyID, value: subCounty.subCountyName});
              }
            }
          })
          .catch((e) => console.error('Error:', e.message));
    },
    getWardsFilter() {
      this.itemList = [];
      const data = new FormData();
      data.append("function", "getWards");
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              const wards = res.data.data.wards || res.data.data;
              for (let i = 0; i < wards.length; i++) {
                let ward = wards[i];
                this.itemList.push({id: ward.wardID, value: ward.wardName});
              }
            }
          })
          .catch((e) => console.error('Error:', e.message));
    },
    getZones() {
      this.itemList = [];
      const data = new FormData();
      data.append("function", "getZones");
      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              for (let i = 0; i < res.data.data.zones.length; i++) {
                let zone = res.data.data.zones[i];
                this.itemList.push({id: zone.id, value: zone.zone});
              }
            }
          })
          .catch((e) => console.error('Error:', e.message));
    },
    getUsers() {
      this.itemList = [];
      const data = new FormData();
      data.append("function", "getUsers");
      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              for (let i = 0; i < res.data.data.users.length; i++) {
                let user = res.data.data.users[i];
                this.itemList.push({id: user.id, value: user.names});
              }
            }
          })
          .catch((e) => console.error('Error:', e.message));
    }
  }
}
</script>

<style scoped>
.mini-stats-wid .card-body {
  padding: 20px;
}

.mini-stat-icon {
  width: 48px;
  height: 48px;
}

.hover-row {
  transition: all 0.3s ease;
  cursor: pointer;
}

.hover-row:hover {
  background-color: #f8f9fa !important;
  transform: translateX(2px);
}

.btn-soft-primary {
  color: #556ee6;
  background-color: rgba(85, 110, 230, 0.18);
  border: none;
}

.btn-soft-primary:hover {
  color: #fff;
  background-color: #556ee6;
}

.btn-soft-success {
  color: #34c38f;
  background-color: rgba(52, 195, 143, 0.18);
  border: none;
}

.btn-soft-success:hover {
  color: #fff;
  background-color: #34c38f;
}

.bg-success-subtle {
  background-color: rgba(52, 195, 143, 0.18);
  color: #34c38f;
}

.bg-warning-subtle {
  background-color: rgba(241, 180, 76, 0.18);
  color: #f1b44c;
}

.search-box .search-icon {
  position: absolute;
  left: 13px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  color: #74788d;
}

.search-box .form-control {
  padding-left: 40px;
}

.table-primary {
  background-color: rgba(85, 110, 230, 0.15) !important;
}

.table-success {
  background-color: rgba(52, 195, 143, 0.15) !important;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1;
}

@media (max-width: 768px) {
  .table-responsive {
    font-size: 0.875rem;
  }

  .btn-sm {
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
  }
}
</style>